export default {
  path: '/player',
  name: 'Player',
  redirect: '/player/list',
  component: () => import('@/components/layout'),
  meta: { requiresAuth: true },
  children: [
    {
      path: 'list',
      component: () => import('@/views/player'),
      meta: { requiresAuth: true }
    },
    {
      path: 'info',
      component: () => import('@/views/player/Info'),
      meta: { requiresAuth: true }
    },
    {
      path: 'moreMedia',
      component: () => import('@/views/media/more'),
      meta: { requiresAuth: true }
    },
    {
      path: 'moreTraining',
      component: () => import('@/views/training/more'),
      meta: { requiresAuth: true }
    },
    {
      path: 'moreMatchTraining',
      component: () => import('@/views/teaching/more'),
      meta: { requiresAuth: true }
    },
    {
      path: 'testData',
      component: () => import('@/views/player/testData'),
      meta: { requiresAuth: true }
    },
    {
      path: 'moreMatchReport',
      component: () => import('@/views/match/more'),
      meta: { requiresAuth: true }
    },
    {
      path: 'playerSearch',
      component: () => import('@/views/player/playerSearch'),
      meta: { requiresAuth: true }
    },
  ]
}
